import PropTypes from 'prop-types';
import { Box, Typography, useTheme } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

export const NavItem = (props) => {
    const { href, icon, title, ...others } = props;
    let location = useLocation();
    const active = href ? (location.pathname === href) : false;
    const theme = useTheme();

    return (
        <Link
            to={href || '#'}
            style={{ textDecoration: 'none', color: 'inherit', display: 'flex', width: '100%' }}
            {...others}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    px: 2,
                    py: 1.2,
                    width: '100%',
                    borderRadius: 0,
                    color: active ? theme.palette.primary.main : theme.palette.text.main,
                    transition: 'all 0.2s ease-in-out',
                    '&:hover': {
                        backgroundColor: theme.palette.background.accent || 'rgba(0, 0, 0, 0.04)',
                        color: theme.palette.primary.main,
                    },
                    ...(active && {
                        backgroundColor: theme.palette.background.accent || 'rgba(0, 0, 0, 0.08)',
                    }),
                }}
            >
                {icon && (
                    <Box
                        sx={{
                            mr: 1.5,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            '& svg': {
                                fontSize: '1.25rem' // Einheitliche Größe für Icons
                            }
                        }}
                    >
                        {icon}
                    </Box>
                )}
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: active ? 800 : 600,
                        lineHeight: 2,
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    {title}
                </Typography>
            </Box>
        </Link>
    );
};

NavItem.propTypes = {
    href: PropTypes.string,
    icon: PropTypes.node,
    title: PropTypes.string
};